import { FC } from 'react';
import { defaultIconProps, IconProps } from './IconProps';

export const IconDbrx: FC<IconProps> = ({ size = 40, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" {...rest} xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2689_6481)">
      <path
        d="M34.3222 16.9288L20.016 25.0881L4.69474 16.3702L3.95828 16.7727V23.1019L20.0145 32.2252L34.3222 24.0965V27.4463L20.016 35.6071L4.69474 26.8877L3.95828 27.2917V28.3781L20.0145 37.5L36.0416 28.3781V22.049L35.3052 21.645L20.016 30.3323L5.67766 22.2035V18.8523L20.016 26.981L36.0416 17.8592V11.6219L35.2439 11.1567L20.016 19.8133L6.41412 12.1192L20.016 4.39292L31.1912 10.7542L32.1727 10.1956V9.41979L20.016 2.5L3.95828 11.6219V12.615L20.0145 21.7369L34.3222 13.5775V16.9288Z"
        fill="#EE3D2C"
      />
    </g>
    <defs>
      <clipPath id="clip0_2689_6481">
        <rect width="35" height="35" fill="white" transform="translate(2.5 2.5)" />
      </clipPath>
    </defs>
  </svg>
);

IconDbrx.defaultProps = defaultIconProps;
